enum ComposedChartRoutesAPI {
  COMPOSED_CHART_TOTAL = '/customer-portal-service/KpiGraphicsGenerated/Total',
}

enum ComposedChartRoutesApplication {
  COMPOSED_CHART = '/application/composed-chart',
}

export {
  ComposedChartRoutesAPI,
  ComposedChartRoutesApplication,
};
